import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import Swal from 'sweetalert2';

/**
 * Popover warning per conferma sincronizzazione ordine.
 * Block inline nel main shell preparazione-ordini-detaggli (J.3),
 * triggered da synchronizeOrder() → openModal.openPopover().
 * Su "Continua" emette modalClosed1 → parent invoca synchroneOrder().
 *
 * Cleanup v2.11.0 J.3:
 * - Drop kendo-dialog + dark-background wrapper.
 * - Pattern Diakonix native modal (backdrop fixed, z-index 2100).
 * - Switch a inject().
 */
@Component({
  selector: 'app-popover-warning',
  templateUrl: './popover-warning.component.html',
  styleUrls: ['./popover-warning.component.scss'],
  standalone: false,
})


export class PopoverWarningComponent {

  @Input() openedWarningMessage = false;
  @Output() modalClosed1 = new EventEmitter<void>();

  private closeModal = inject(OpenModalService);

  confirm(): void {
    this.modalClosed1.emit();
    this.closeModal.closePopover();
    Swal.fire({
      icon: 'success',
      title: 'Modificato!',
      text: 'Ordine aggiornato con successo.',
      timer: 1500,
      timerProgressBar: true,
    });
  }

  cancel(): void {
    this.closeModal.closePopover();
  }
  
}
